module.exports = __webpack_public_path__ + "static/media/reader.a3fa1994.png";